import React from 'react';
import Icon from '../../../../common/components/icons/Icon';
import { primitiveColors, spacing } from '../../../../theming';
import { Divider, Flex, Tooltip } from 'antd';
import styles from './PlanCard.module.scss';
import { useTranslation } from 'react-i18next';
import { useMedia } from '../../../../hooks/useMediaQuery';
import { useMediaQuery } from '@uidotdev/usehooks';
import PurchaseReportButton from '../PurchaseReportButton/PurchaseReportButton';
import { usePaymentContext } from '../../../../context/PaymentContext';
import ReactGA from 'react-ga4';
import { googleAnalyticsEvents } from '../../../../common/constants/googleAnalyticsEvents';

const PlanCard = ({ plan }) => {
    const {
        title,
        price,
        currency,
        discount,
        description,
        priceWithDiscount,
        buttonText,
        isPopular,
        benefits,
        credits,
    } = plan;
    const { setSelectedPlan, selectedPlan } = usePaymentContext();
    const { isSmallDevice, isLargeDevice } = useMedia();
    const getButtonBreakpoint = useMediaQuery('(max-width: 1107px)');
    const { t } = useTranslation(['payment']);

    const isDiscount = parseInt(discount) !== 0;
    const isPlanSelected = selectedPlan && selectedPlan.credits === credits;

    const handlePlanSelection = plan => {
        setSelectedPlan(plan);

        ReactGA.event(googleAnalyticsEvents.SELECT_PLAN_CLICK, {
            plan_name: plan.productName,
        });
    };

    return (
        <div
            className={`${styles.planCard} ${isPlanSelected ? styles.selected : ''}`}
            style={{ minWidth: isSmallDevice ? '352px' : isLargeDevice ? '300px' : 'auto' }}
        >
            {isPopular && <div className={styles.popularBadge}>{t('plans.popular')}</div>}
            <h3>{title}</h3>
            <p className={`${styles.price} ${isPlanSelected ? styles.selected : ''}`}>
                {currency}
                {price.toFixed(2)} <span className={styles.report}>/ {t('plans.report')}</span>
            </p>
            <p className={styles.description}>{description}</p>
            <p className={styles.description}>{priceWithDiscount}</p>
            <p className={`${styles.discount} ${!isDiscount && styles.discountOff}`}>
                {discount} {isDiscount && t('plans.discount')}
            </p>
            <Flex vertical gap={spacing[1]}>
                <button
                    className={`${styles.selectButton} ${isPlanSelected && styles.activeButton}`}
                    onClick={() => handlePlanSelection(plan)}
                >
                    {isPlanSelected && <Icon name="CheckPlan" size={24} />}
                    {isPlanSelected ? t('plans.buttonSelected') : buttonText}
                </button>
            </Flex>
            <Divider
                style={{
                    backgroundColor: primitiveColors.divider,
                    height: 1,
                    marginTop: getButtonBreakpoint ? spacing[4] : spacing[6],
                    marginBottom: getButtonBreakpoint ? spacing[4] : spacing[6],
                    minWidth: 'auto',
                }}
            />
            <div className={styles.benefits}>
                {benefits.map((benefit, index) => (
                    <div key={index} className={styles.benefitItem}>
                        <div className={styles.benefitContent}>
                            <Icon name="CheckBenefit" size={14} style={{ flexShrink: 0 }} />
                            <span className={styles.benefitText}>{benefit.text}</span>
                        </div>
                        <Tooltip title={benefit.tooltip} placement="top">
                            <Icon name="Info" size={14} style={{ flexShrink: 0 }} />
                        </Tooltip>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PlanCard;
